import { DangerButton, DefaultButton, PrimaryButton, WarningButton } from "@/components/Buttons";
import { Pressable, ThemeText } from "@/components/Theme";
import colors from "@/constants/Colors";
import { useCurrentUrl } from "@/hooks/useCurrentUrl";
import { useScrollTo } from '@nandorojo/anchor';
import { Link, useRouter } from "expo-router";
import { StyleSheet } from "react-native";

const HashLink = ({ children, href }) => {
    const { rawUrlPath } = useCurrentUrl();
    const { scrollTo } = useScrollTo();

    const onPress = () => {
        const targetId = href.slice(1);
        scrollTo(targetId, { animated: true});
    }

    const path = `${rawUrlPath}${href}`;

    return (
        <Link push asChild href={path}>
            <Pressable onPress={onPress}>
                <ThemeText variant={'pbold,bmwLightBlue.main'}>
                    {children}
                </ThemeText>
            </Pressable>
        </Link>
    );
}

const LinkHandler = ({href, title, children, isButton, styles}) => {
    const router = useRouter();
    
    const onPressHandler = (href) => {
        if (href?.startsWith('/')) {
            return router.push(href);
        }

        if (href?.startsWith('q=')) {
            return router.setParams({ q: href.slice(2) });
        }
    }

    if (isButton) {
        const decodedHref = decodeURIComponent(href);
        const [actualHref, ...rest] = decodedHref.split('|').map(s => s.trim());
        
        const type = rest[0] ?? null;
        const size = rest[1] ?? 'md';
        const text = children[0]?.props?.children || '';

        if (text == '')
            return null;

        if (type != null) {

            if (type == 'primary')
                return <PrimaryButton title={text} size={size} onPress={() => onPressHandler(actualHref)} />

            if (type == 'warning')
                return <WarningButton title={text} size={size} onPress={() => onPressHandler(actualHref)} />

            if (type == 'default')
                return <DefaultButton title={text} size={size} onPress={() => onPressHandler(actualHref)} />

            if (type == 'danger')
                return <DangerButton title={text} size={size} onPress={() => onPressHandler(actualHref)} />
            
        }
        
        return (
            <Link
                title={title || ''}
                style={[
                    { 
                    backgroundColor: colors.bmwLightBlue.main,
                    color: 'white',
                    fontSize: 18,
                    fontWeight: '500',
                    lineHeight: 24,
                    textDecorationLine: 'none',
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    ...styles.link
                    }
                ]}
                href={actualHref}
                target={actualHref?.startsWith('http') ? '_blank' : undefined}
                push
            >
                <ThemeText>{children}</ThemeText>
            </Link>
        );
    }

    if (href?.startsWith('/')) {
        return (
            <Link
                title={title}
                href={href}
                push
            >
                <ThemeText variant={'pbold,bmwLightBlue.main'}>{children}</ThemeText>
            </Link>
        );
    }
          
    if (href?.startsWith('q=')) {
        return (
            <Pressable
                title={title}
                onPress={() => router.setParams({ q: href.slice(2) })}
            >
                <ThemeText variant={'pbold,bmwLightBlue.main'}>{children}</ThemeText>
            </Pressable>
        )
    }
    
    return (
        <Link
            href={href}
            title={title}
            target={href?.startsWith('http') ? '_blank' : undefined}
            push
        >
            <ThemeText style={[styles.link, s.link]} variant={'pbold,bmwLightBlue.main'}>{children}</ThemeText>
        </Link>
    );
}

export function linkParser(node, children, parent, styles, colorScheme) {
    const href = node.attributes?.href;
    const title = node.attributes?.title ;
    const isButton = href?.includes('%7C');

    if (href?.startsWith('#')) {
        return <HashLink key={node.key} href={href}>{children}</HashLink>;
    }

    return (
        <LinkHandler 
            key={node.key} 
            href={href}
            styles={styles} 
            title={title} 
            isButton={isButton} 
            children={children} 
        />
    );
}

const s = StyleSheet.create({
    link: {
        color: colors.bmwLightBlue.main,
        fontWeight: '500',
        textDecorationLine: 'none'
    }
});